import { Component, Input, forwardRef } from '@angular/core';

import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';
import { CheckboxFieldModel } from '../../../models/checkbox-field.model';

@Component({
    selector: 'agpr-checkbox-field',
    templateUrl: './checkbox-field.component.html',
    styleUrls: ['./checkbox-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => CheckboxFieldComponent)
        }
    ],
    standalone: false
})
export class CheckboxFieldComponent extends AbstractFormFieldComponent {
    @Input() declare field: CheckboxFieldModel;
    @Input() twoColumns: boolean = false;
}
